import { render, staticRenderFns } from "./TabsPitch.vue?vue&type=template&id=f22e2fc8"
import script from "./TabsPitch.vue?vue&type=script&lang=js"
export * from "./TabsPitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports